var scope_0 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0dea1e4557049f6bf0de990f7a9fa7a4.js').default;

var scope_1 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/138f7e51c45a27fe166c766a382af489.js').default;

var scope_2 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1dadbd8cf48ca4ce5fefcc8cb54ad301.js').default;

var scope_3 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4813be62010db4b0678f799744cff08f.js').default;

var scope_4 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5010d0454d331f17b3f362300c332815.js').default;

var scope_5 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5efd695976fb68b8a043e22b04553f09.js').default;

var scope_6 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/854378ffe09a60c3d19d96866187d23a.js').default;

var scope_7 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c533672b65eceda7f54713362ba9323f.js').default;

var scope_8 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dbcbe379ecc805f570fb4b0b608035f6.js').default;

var scope_9 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e7a119a01d0baaea55902f4eddee8674.js').default;

var scope_10 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_11 = require('/vercel/path0/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f40154fa24d02232a334c70c31d363fe.js').default;

const __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "../../node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "../../node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}